export default __webpack_public_path__ + "static/media/illustration-signal.611d41a1.svg";